import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6d7ba78c"
import script from "./Profile.ts?vue&type=script&lang=js&external"
export * from "./Profile.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports